import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import AuthenticatedFooterDock from "./AuthenticatedFooterDock";
import { PublicFooter, PublicHeaderNav } from "./PublicSiteChrome";
import logo from "./assets/logofinal-flat.png";
import "./HomeV2.css";
import "./SiteLayouts.css";


function AuthenticatedFrame({ onLogout, publicContent = false, children }) {
  return (
    <div className="d-flex wv-authFrame">
      <Navbar onLogout={onLogout} />
      <main className="wv-authFrameMain">
        <div className={publicContent ? "wv-authPublicRoute" : "wv-authAppRoute"}>
          {children}
        </div>
      </main>
      <AuthenticatedFooterDock />
    </div>
  );
}

export function PublicSiteLayout() {
  const location = useLocation();

  useEffect(() => {
    const root = document.querySelector(".wv-publicSiteContent");
    if (!root) return undefined;

    const cleanupByVideo = new Map();

    const configureVideo = (video) => {
      if (!(video instanceof HTMLVideoElement) || cleanupByVideo.has(video)) return;

      const playMuted = () => {
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        const promise = video.play?.();
        if (promise?.catch) promise.catch(() => {});
      };

      const playWithSound = () => {
        video.muted = false;
        video.volume = 1;
        const promise = video.play?.();
        if (promise?.catch) promise.catch(() => {});
      };

      const keepPlayingMuted = () => {
        video.muted = true;
        const promise = video.play?.();
        if (promise?.catch) promise.catch(() => {});
      };

      video.addEventListener("mouseenter", playWithSound);
      video.addEventListener("mouseleave", keepPlayingMuted);
      video.addEventListener("focus", playWithSound);
      video.addEventListener("blur", keepPlayingMuted);
      video.addEventListener("loadeddata", playMuted);
      playMuted();

      cleanupByVideo.set(video, () => {
        video.removeEventListener("mouseenter", playWithSound);
        video.removeEventListener("mouseleave", keepPlayingMuted);
        video.removeEventListener("focus", playWithSound);
        video.removeEventListener("blur", keepPlayingMuted);
        video.removeEventListener("loadeddata", playMuted);
      });
    };

    const scan = (scope) => {
      if (scope instanceof HTMLVideoElement) configureVideo(scope);
      scope?.querySelectorAll?.("video").forEach(configureVideo);
    };

    scan(root);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    });
    observer.observe(root, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      cleanupByVideo.forEach((cleanup) => cleanup());
      cleanupByVideo.clear();
    };
  }, [location.pathname]);

  return (
    <div className="wv-publicSiteShell">
      <header className="hv2-nav hv2-navPersistent wv-centralPublicHeader" aria-label="Weavevo navigation">
        <a className="hv2-brand" href="/" aria-label="Weavevo home">
          <img src={logo} alt="Weavevo" />
          <span>weavevo</span>
        </a>
        <PublicHeaderNav loginHref="/homeV2#product" />
      </header>

      <div className="wv-publicSiteContent">
        <Outlet />
      </div>

      <PublicFooter currentPath={location.pathname} />
    </div>
  );
}

export function AuthenticatedAppLayout({ onLogout, children }) {
  return (
    <AuthenticatedFrame onLogout={onLogout}>
      {children || <Outlet />}
    </AuthenticatedFrame>
  );
}

export function HomeRouteLayout({ children }) {
  return children;
}
